import imageGalleryTemplate from './image_gallery.template.html';

class WbImageGalleryController {

    constructor(Lightbox) {
        'ngInject';

        const injectables = {
            Lightbox
        };

        Object.assign(this, injectables);
    }

    $onInit() {
        if (this.images) {
            let imageUrls = this.images.split("\n");
            this.galleryImages = [];
            imageUrls.forEach(url => {
                this.galleryImages.push({
                    url,
                    thumbUrl: url
                });
            });
        }
    }

    openLightboxModal(index) {
        this.Lightbox.openModal(this.galleryImages, index);
    };
}

const WbImageGalleryComponent = {
    templateUrl: imageGalleryTemplate.id,
    controller: WbImageGalleryController,
    controllerAs: '$wbImageGalleryCtrl',
    bindings: {
        images: '<'
    }
};

angular
    .module('westBerkshireEvents.imageGallery')
    .component('wbImageGallery', WbImageGalleryComponent);

export default WbImageGalleryController;


// WEBPACK FOOTER //
// ../src/public/javascripts/image-gallery/image_gallery.component.js